/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Referral_Reward_ActiveInputs */

const en_plan_referral_reward_active = /** @type {(inputs: Plan_Referral_Reward_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referral reward active`)
};

const es_plan_referral_reward_active = /** @type {(inputs: Plan_Referral_Reward_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recompensa de referido activa`)
};

/**
* | output |
* | --- |
* | "Referral reward active" |
*
* @param {Plan_Referral_Reward_ActiveInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_referral_reward_active = /** @type {((inputs?: Plan_Referral_Reward_ActiveInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Referral_Reward_ActiveInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_referral_reward_active(inputs)
	return en_plan_referral_reward_active(inputs)
});